import React from 'react';
import { BankAccount } from '../props';
import { BankAccountRadioProps, strToUppercase } from '../utils';
import { SnapIcon } from '../../SnapIcon';
import { SnapBadge } from '../../SnapBadge';

export default function BankAccountCard({
  isOrgDefaultAccount,
  selected,
  bankAccount,
  payoutInterval,
  displayError,
  onUpdatePayoutClick,
  onRadioSelect,
}: {
  isOrgDefaultAccount: boolean;
  selected: boolean;
  bankAccount: BankAccount | undefined;
  payoutInterval?: string;
  displayError: boolean;
  onUpdatePayoutClick: (option: BankAccountRadioProps) => void;
  onRadioSelect: (option: BankAccountRadioProps) => void;
}): React.JSX.Element {
  return (
    <label
      htmlFor={bankAccount?.id}
      className={`flex flex-col items-center mt-4 mb-2 rounded-lg shadow 'bg-white border border-gray-200'
      ${selected ? 'bg-blue-100 border-2 border-blue-500' : {}}

      ${displayError ? 'border-2 border-red-500' : {}}
        `}
    >
      <div className={`w-full flex flex-row px-2 py-4`}>
        <div className='flex items-start'>
          <input
            type='radio'
            className='mt-1.5'
            checked={selected}
            onChange={(): void =>
              onRadioSelect({
                type: isOrgDefaultAccount ? 'payableOrg' : 'campaign',
              })
            }
            id={bankAccount?.id}
          />
          <div className='flex flex-col'>
            <div className='flex flex-col gap-2'>
              <div className='font-medium mb-2'>
                {isOrgDefaultAccount
                  ? `Organization's Default Account`
                  : 'Custom Bank Account'}
              </div>

              <div className='flex flex-row items-center gap-2'>
                <SnapIcon icon={'bank'} color={'#475569'} size='md' />
                <div className='flex  flex-col items-center'>
                  <p className='text-sm font-medium leading-5 text-gray-800 mx-2'>
                    {bankAccount?.bank_name}
                  </p>
                </div>

                <div className='flex row items-center'>
                  {Array(4)
                    .fill(1)
                    .map((_, idx) => (
                      <SnapIcon
                        key={idx}
                        icon={'dot-solid'}
                        color={'#1E293B'}
                        size='micro'
                      />
                    ))}
                  <p className='text-sm text-gray-800 font-bold cursor-pointer'>
                    {bankAccount?.last4}
                  </p>
                </div>
              </div>
              <div className='flex flex-row items-center gap-2'>
                <p className='text-sm font-normal leading-5 text-gray-600'>
                  Payout
                </p>
                {bankAccount?.default_for_currency &&
                  payoutInterval !== undefined && (
                    <SnapBadge
                      label={strToUppercase(payoutInterval)}
                      variant='gray'
                      className='mb-1 mx-1'
                    />
                  )}
                {selected && !isOrgDefaultAccount && (
                  <button
                    className='text-blue-700 text-sm font-bold leading-5'
                    onClick={(): void =>
                      onUpdatePayoutClick({
                        type: isOrgDefaultAccount ? 'payableOrg' : 'campaign',
                      })
                    }
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </label>
  );
}
